export default "__VITE_ASSET__f7813871__"